"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

var _StyledRect = _interopRequireDefault(require("./StyledRect"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } _setPrototypeOf(subClass.prototype, superClass && superClass.prototype); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.getPrototypeOf || function _getPrototypeOf(o) { return o.__proto__; }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var zoomableMap = {
  'n': 't',
  's': 'b',
  'e': 'r',
  'w': 'l',
  'ne': 'tr',
  'nw': 'tl',
  'se': 'br',
  'sw': 'bl'
};

var Rect = function (_PureComponent) {
  function Rect() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, Rect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Rect)).call.apply(_getPrototypeOf2, [this].concat(args))), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setElementRef", function (ref) {
      return _this.$element = ref;
    }), "startDrag", function (e) {
      var startX = e.clientX,
          startY = e.clientY;
      _this.props.onDragStart && _this.props.onDragStart();
      _this._isMouseDown = true;

      var onMove = function onMove(e) {
        if (!_this._isMouseDown) return;
        e.stopImmediatePropagation();
        var clientX = e.clientX,
            clientY = e.clientY;
        var deltaX = clientX - startX;
        var deltaY = clientY - startY;

        _this.props.onDrag(deltaX, deltaY);

        startX = clientX;
        startY = clientY;
      };

      var onUp = function onUp() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        if (!_this._isMouseDown) return;
        _this._isMouseDown = false;
        _this.props.onDragEnd && _this.props.onDragEnd();
      };

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    }), "startRotate", function (e) {
      if (e.button !== 0) return;
      var clientX = e.clientX,
          clientY = e.clientY;
      var startAngle = _this.props.styles.transform.rotateAngle;

      var rect = _this.$element.getBoundingClientRect();

      var center = {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2
      };
      var startVector = {
        x: clientX - center.x,
        y: clientY - center.y
      };
      _this.props.onRotateStart && _this.props.onRotateStart();
      _this._isMouseDown = true;

      var onMove = function onMove(e) {
        if (!_this._isMouseDown) return;
        e.stopImmediatePropagation();
        var clientX = e.clientX,
            clientY = e.clientY;
        var rotateVector = {
          x: clientX - center.x,
          y: clientY - center.y
        };
        var angle = (0, _utils.getAngle)(startVector, rotateVector);

        _this.props.onRotate(angle, startAngle);
      };

      var onUp = function onUp() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        if (!_this._isMouseDown) return;
        _this._isMouseDown = false;
        _this.props.onRotateEnd && _this.props.onRotateEnd();
      };

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    }), "startResize", function (e, cursor) {
      if (e.button !== 0) return;
      document.body.style.cursor = cursor;
      var _this$props$styles = _this.props.styles,
          _this$props$styles$po = _this$props$styles.position,
          centerX = _this$props$styles$po.centerX,
          centerY = _this$props$styles$po.centerY,
          _this$props$styles$si = _this$props$styles.size,
          width = _this$props$styles$si.width,
          height = _this$props$styles$si.height,
          rotateAngle = _this$props$styles.transform.rotateAngle;
      var startX = e.clientX,
          startY = e.clientY;
      var rect = {
        width: width,
        height: height,
        centerX: centerX,
        centerY: centerY,
        rotateAngle: rotateAngle
      };
      var type = e.target.getAttribute('class').split(' ')[0];
      _this.props.onResizeStart && _this.props.onResizeStart();
      _this._isMouseDown = true;

      var onMove = function onMove(e) {
        if (!_this._isMouseDown) return;
        e.stopImmediatePropagation();
        var clientX = e.clientX,
            clientY = e.clientY;
        var deltaX = clientX - startX;
        var deltaY = clientY - startY;
        var alpha = Math.atan2(deltaY, deltaX);
        var deltaL = (0, _utils.getLength)(deltaX, deltaY);
        var isShiftKey = e.shiftKey;

        _this.props.onResize(deltaL, alpha, rect, type, isShiftKey);
      };

      var onUp = function onUp() {
        document.body.style.cursor = 'auto';
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        if (!_this._isMouseDown) return;
        _this._isMouseDown = false;
        _this.props.onResizeEnd && _this.props.onResizeEnd();
      };

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    }), _temp));
  }

  _createClass(Rect, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$styles2 = _this$props.styles,
          _this$props$styles2$p = _this$props$styles2.position,
          centerX = _this$props$styles2$p.centerX,
          centerY = _this$props$styles2$p.centerY,
          _this$props$styles2$s = _this$props$styles2.size,
          width = _this$props$styles2$s.width,
          height = _this$props$styles2$s.height,
          rotateAngle = _this$props$styles2.transform.rotateAngle,
          zoomable = _this$props.zoomable,
          rotatable = _this$props.rotatable,
          parentRotateAngle = _this$props.parentRotateAngle;
      var style = {
        width: Math.abs(width),
        height: Math.abs(height),
        transform: "rotate(".concat(rotateAngle, "deg)"),
        left: centerX - Math.abs(width) / 2,
        top: centerY - Math.abs(height) / 2
      };
      var direction = zoomable.split(',').map(function (d) {
        return d.trim();
      }).filter(function (d) {
        return d;
      });
      return _react.default.createElement(_StyledRect.default, {
        innerRef: this.setElementRef,
        onMouseDown: this.startDrag,
        className: "rect single-resizer",
        style: style
      }, rotatable && _react.default.createElement("div", {
        className: "rotate",
        onMouseDown: this.startRotate
      }, _react.default.createElement("i", null)), direction.map(function (d) {
        var cursor = "".concat((0, _utils.getCursor)(rotateAngle + parentRotateAngle, d), "-resize");
        return _react.default.createElement("div", {
          key: d,
          style: {
            cursor: cursor
          },
          className: "".concat(zoomableMap[d], " resizable-handler"),
          onMouseDown: function onMouseDown(e) {
            return _this2.startResize(e, cursor);
          }
        });
      }), direction.map(function (d) {
        return _react.default.createElement("div", {
          key: d,
          className: "".concat(zoomableMap[d], " square")
        });
      }));
    }
  }]);

  _inherits(Rect, _PureComponent);

  return Rect;
}(_react.PureComponent);

exports.default = Rect;

_defineProperty(Rect, "propTypes", {
  styles: _propTypes.default.object,
  zoomable: _propTypes.default.string,
  rotatable: _propTypes.default.bool,
  onResizeStart: _propTypes.default.func,
  onResize: _propTypes.default.func,
  onResizeEnd: _propTypes.default.func,
  onRotateStart: _propTypes.default.func,
  onRotate: _propTypes.default.func,
  onRotateEnd: _propTypes.default.func,
  onDragStart: _propTypes.default.func,
  onDrag: _propTypes.default.func,
  onDragEnd: _propTypes.default.func,
  parentRotateAngle: _propTypes.default.number
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-resizable-rotatable-draggable/lib/components/Rect/index.js
// module id = 1071
// module chunks = 0